module.exports = __webpack_public_path__ + "img/8.6fdee826.png";